import moment from "moment";

import { Base2Presenter } from "core/presenter";
import { SaleRepository } from "core/repository";

import * as R from "ramda";

class MyFinancePendingTransactionsPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      order: [
        {
          field: "activated_at",
          direction: "DESC"
        }
      ],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      filters: {
        startDate: moment()
          .subtract(30, "days")
          .startOf("day"),
        endDate: moment().endOf("day")
      },
      receivables: [],
      payments: []
    };
  }

  async onStart() {
    await this.checkPendingTransactions();
  }

  async checkPendingTransactions() {
    this.enqueue({ loading: true });
    const { order, pagination } = this.viewModel;
    const filters = await this.getFilters();
    const repositoryResult = await SaleRepository.getListOnline({
      order,
      pagination,
      filters
    });

    if (repositoryResult.success) {
      if (parseInt(repositoryResult.total, 10) === 0) {
        this.sendNotification({
          type: "success",
          content: "Não há transações pendentes."
        });
        this.props.onPendingTransactionsClose();
      } else {
        const receivableMapper = R.pathOr(
          [],
          ["processed_integrations", "my_finance"]
        );
        const mapperAmbiguous = R.pathOr(
          [],
          ["processed_integrations", "my_finance", "ambiguous_payments"]
        );
        const mapperNotFound = R.pathOr(
          [],
          ["processed_integrations", "my_finance", "not_found_payments"]
        );

        this.enqueue(vm => ({
          receivables: repositoryResult.data
            .map(receivableMapper)
            .filter(
              r =>
                (r.ambiguous_payments && r.ambiguous_payments.length > 0) ||
                (r.not_found_payments && r.not_found_payments.length > 0)
            ),
          payments: repositoryResult.data.reduce(
            (cur, sale) => [
              ...cur,
              ...mapperAmbiguous(sale),
              ...mapperNotFound(sale)
            ],
            []
          ),
          pagination: {
            ...vm.pagination,
            total: repositoryResult.total,
            perPage: repositoryResult.perPage
          }
        }));
      }
    } else {
      this.sendNotification({
        type: "error",
        title: "Ooopss...",
        content:
          "Não foi possível carregar os pagamentos não conciliados.\nTente novamente mais tarde ou entre em contato com o suporte."
      });
      this.props.onPendingTransactionsClose();
    }
    this.enqueue({ loading: false });
  }

  // async getPendingTransactions() {
  //   const { order, pagination } = this.viewModel;
  //   const filters = await this.getFilters();
  //   const repositoryResult = await SaleRepository.getListOnline({
  //     order,
  //     pagination,
  //     filters,
  //   });

  //   if (repositoryResult.success) {
  //     const filteredSales = [];
  //     // for (const sale of repositoryResult.data) {
  //     await repositoryResult.data.forEach(async (sale) => {
  //       if (sale.processed_integrations.my_finance &&
  //         sale.processed_integrations.my_finance.fully_processed === false) {
  //           filteredSales.push(sale.processed_integrations.my_finance);
  //         }
  //     });

  //     this.enqueue((vm) => ({
  //       sales: filteredSales,
  //       pagination: {
  //         ...vm.pagination,
  //         total: repositoryResult.total,
  //         perPage: repositoryResult.perPage,
  //       }
  //     }));
  //   } else {
  //     this.sendNotification({
  //       type: 'error',
  //       title: 'Ooopss...',
  //       content: 'Não foi possível carregar os pagamentos não conciliados.\nTente novamente mais tarde ou entre em contato com o suporte.',
  //     });
  //   }
  // }

  async getFilters() {
    const { startDate, endDate } = this.viewModel.filters;
    const currentUser = await this.mRuntime.get("currentUser");

    const filters = [
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: currentUser.company_uuid
      },
      {
        connector: "AND",
        field: "processed_integrations.my_finance.fully_processed",
        operation: "EQ",
        value: "false"
      }
    ];

    if (startDate) {
      filters.push({
        connector: "AND",
        field: "activated_at",
        operation: "GTE",
        value: startDate.toISOString()
      });
    }

    if (endDate) {
      filters.push({
        connector: "AND",
        field: "activated_at",
        operation: "LTE",
        value: endDate.toISOString()
      });
    }

    return filters;
  }

  onPageChange(page) {
    this.enqueue(
      vm => ({ pagination: { ...vm.pagination, page } }),
      () => this.checkPendingTransactions()
    );
  }
}

export default MyFinancePendingTransactionsPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/my-finance/pending-transactions/presenter.js